<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4 text-dark">Add New Material</h4>

      <form @submit.prevent="handleSubmit">
        <div class="row">
          <!-- Name -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="name" class="form-label">{{ $t('common.labels.name') }}</label>
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="form.name"
                :placeholder="$t('common.placeholders.enterMaterialName')"
                required
              />
            </div>
          </div>

          <!-- Reference -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="reference" class="form-label">{{ $t('common.labels.reference') }}</label>
              <input
                type="text"
                class="form-control"
                id="reference"
                v-model="form.reference"
                :placeholder="$t('common.placeholders.enterReference')"
                required
              />
            </div>
          </div>

          <!-- Serial Number -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="serialNumber" class="form-label">Serial Number</label>
              <input
                type="text"
                class="form-control"
                id="serialNumber"
                v-model="form.serialNumber"
                :placeholder="$t('common.placeholders.enterSerialNumber')"
                required
              />
            </div>
          </div>

          <!-- Type -->
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="type" class="form-label">{{ $t('common.labels.type') }}</label>
              <input
                type="text"
                class="form-control"
                id="type"
                v-model="form.type"
                :placeholder="$t('common.placeholders.enterType')"
                required
              />
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="text-end">
          <button type="submit" class="btn text-white px-4" style="background-color: #b03a45;">
            Add Material
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddMateriel",
  data() {
    return {
      form: {
        name: "",
        reference: "",
        serialNumber: "",
        type: ""
      }
    };
  },
  methods: {
    handleSubmit() {
      console.log("Material added:", this.form);
      alert("Material added successfully!");
      this.$router.push("/materiall");
    }
  }
};
</script>
